// extracted by mini-css-extract-plugin
module.exports = {"panel":"default-panel_panel__2O9iL","text":"default-panel_text__2x793"};